import { Injectable } from '@angular/core';
import { GaSessionConfig, GaSessionConfigLsKeys } from '../models/index';

@Injectable({
    providedIn: 'root',
})
export class GaSessionConfigService {

    #config: GaSessionConfig = new GaSessionConfig();

    get config(): GaSessionConfig { return this.#config; }

    get enabled(): boolean { return this.#config?.enabled ?? false; }
    get autorizedUrl(): string { return this.#config?.autorizedUrl ?? ''; }
    get unautorizedUrl(): string { return this.#config?.unautorizedUrl ?? ''; }
    get serverUrl(): string { return this.#config?.serverUrl ?? ''; }
    get lsKeys(): GaSessionConfigLsKeys { return this.#config?.lsKeys || new GaSessionConfigLsKeys(); }

    addConfig(config: GaSessionConfig): void {
        this.#config.enabled = config?.enabled ?? this.enabled;
        this.#config.autorizedUrl = config?.autorizedUrl ?? this.autorizedUrl;
        this.#config.unautorizedUrl = config?.unautorizedUrl ?? this.unautorizedUrl;
        this.#config.serverUrl = config?.serverUrl ?? this.serverUrl;
        this.#config.lsKeys = { ...this.lsKeys, ...(config?.lsKeys || []) };
    }
}
